import { Link } from 'react-router-dom';

const sitemapSections = [
  {
    title: 'Main Pages',
    links: [
      { name: 'Home', path: '/' },
      { name: 'Services', path: '/services' },
      { name: 'About Us', path: '/about' },
      { name: 'Service Areas', path: '/service-areas' },
      { name: 'Contact', path: '/contact' },
    ],
  },
  {
    title: 'Our Services',
    links: [
      { name: 'Hardwood Flooring Installation', path: '/services' },
      { name: 'Vinyl Flooring Installation', path: '/services' },
      { name: 'Laminate Flooring Installation', path: '/services' },
      { name: 'Tile Flooring Installation', path: '/services' },
      { name: 'Carpet Installation', path: '/services' },
      { name: 'Floor Repair & Replacement', path: '/services' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { name: 'Privacy Policy', path: '/privacy-policy' },
      { name: 'Terms & Conditions', path: '/terms' },
      { name: 'Disclaimer', path: '/disclaimer' },
    ],
  },
];

export const SitemapPage = () => {
  return (
    <main className="pt-20" data-testid="sitemap-page">
      {/* Page Header */}
      <section className="page-header py-16 lg:py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-amber-950 font-serif mb-4">
              Sitemap
            </h1>
            <p className="text-stone-600">Navigate our website easily</p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 section-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-12">
            {sitemapSections.map((section, index) => (
              <div key={index}>
                <h2 className="text-xl font-semibold text-amber-950 font-serif mb-6 pb-2 border-b border-stone-200">
                  {section.title}
                </h2>
                <ul className="space-y-3">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link
                        to={link.path}
                        className="text-stone-600 hover:text-amber-600 transition-colors"
                        data-testid={`sitemap-link-${index}-${linkIndex}`}
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-16 pt-8 border-t border-stone-200">
            <div className="bg-stone-50 rounded-xl p-6">
              <h3 className="text-lg font-semibold text-amber-950 font-serif mb-4">Contact Information</h3>
              <p className="text-stone-600 mb-4">
                <strong>Buy Fusion - Premium Flooring Co.</strong><br />
                88 Sunset Boulevard, Los Angeles, CA 800134
              </p>
              <p className="text-stone-600">
                Phone: <a href="tel:+18888791244" className="text-amber-600 hover:text-amber-700">+1-888-879-1244</a><br />
                Email: <a href="mailto:support@buyfusion.store" className="text-amber-600 hover:text-amber-700">support@buyfusion.store</a>
              </p>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-stone-200">
            <Link to="/" className="text-amber-600 hover:text-amber-700 font-medium">
              ← Back to Home
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default SitemapPage;
